export function FetchFromLocalStorage<T>(key: string): T {
    if (typeof localStorage === 'undefined') {
        return undefined as T;
    }

    try {
        return JSON.parse(localStorage.getItem(key) as string) as T;
    } catch {
        return undefined as T;
    }
}
